import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngxs/store';
import { ShellState } from '../../shell.state';
import { ButtonComponent } from 'ui-elements/button';
import { ImageWithLoaderComponent } from '../../../building-blocks/components/image-with-loader/image-with-loader.component';
import { SplitLinesPipe } from 'common';
import { AmpersandLogoComponent } from '../ampersand-logo/ampersand-logo.component';

@Component({
  selector: 'ss-www-desktop-footer',
  imports: [
    CommonModule,
    RouterModule,
    ButtonComponent,
    ImageWithLoaderComponent,
    SplitLinesPipe,
    AmpersandLogoComponent,
  ],
  templateUrl: './desktop-footer.component.html',
  styleUrls: ['./desktop-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopFooterComponent {
  mappedFooterContentSections$ = inject(Store).select(
    ShellState.mappedFooterContentSections
  );
  socialLinks$ = inject(Store).select(ShellState.socialLinks);
  year = new Date().getFullYear();

  linkSections = [
    ['liveOnStage', 'featureFilms', 'streaming'],
    ['opportunities', 'shop'],
    ['more'],
    ['generalInquiries', 'lancaster', 'branson'],
  ];
}
